import { Download } from 'lucide-react';
import { Button } from './ui/button';

// Renders the pre-generated branded QR code (public/thachari-qr.png, points
// at thachari.com) with an optional download button.
export default function QRCodeDisplay({
  size = 200,
  showDownload = true,
  caption = 'Scan to visit Thachari',
}) {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/thachari-qr.png';
    link.download = 'thachari-qr-code.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="inline-flex flex-col items-center text-center">
      <div className="inline-block rounded-xl bg-white p-3 shadow-md">
        <img
          src="/thachari-qr.png"
          alt="Thachari QR Code"
          width={size}
          height={size}
          className="block rounded"
        />
      </div>

      {caption && (
        <p className="mt-2 mb-0.5 text-sm font-medium text-muted-foreground">{caption}</p>
      )}

      <p className="mb-2 text-xs text-muted-foreground/70">thachari.com</p>

      {showDownload && (
        <Button variant="outline" size="sm" onClick={handleDownload} className="rounded-full">
          <Download className="w-3.5 h-3.5 mr-1.5" />
          Download QR Code
        </Button>
      )}
    </div>
  );
}
